import type { LocationQuery, LocationQueryValue } from 'vue-router';
import { encodeVoucherPayload } from '~~/helpers/voucherEncodeDecode';
import { decodeBase64Json } from '~~/helpers/dataStructure/decodeBase64Json';

type DecodedHash = {
  redirect_to?: string;
  voucher_code?: string;
};

function firstQueryValue(value: LocationQueryValue | LocationQueryValue[] | undefined): string | undefined {

  if (Array.isArray(value)) {

    return typeof value[0] === 'string' ? value[0] : undefined;

  }

  return typeof value === 'string' ? value : undefined;

}



function getLanguagePrefix(path: string): string {

  const stringStartWithLanguageCodeRegEx = /^\/[a-z][a-z]\//;
  const routePrefix = path.slice(0, 4);

  return stringStartWithLanguageCodeRegEx.test(routePrefix) ? routePrefix : '/';

}

function withoutLeadingSlash(path: string): string {

  return path.startsWith('/') ? path.slice(1) : path;

}

export default defineNuxtRouteMiddleware(async (to) => {

  // Handling old Shopware url's for confirming acceptance of newsletter
  // and showing manage subscriptions page without logging in
  switch (true) {

    case to.path.endsWith('/exConsents/confirm'):
      return handleConfirmRequest({
        path: to.path,
        query: to.query,
      });
    case to.path.endsWith('/exConsents/manageSubscriptions'):
      return handleMSPageRequest(to.query);

  }

});

function handleConfirmRequest(
  to: { path: string; query: LocationQuery },
) {

  const hash = firstQueryValue(to.query.hash);

  const queryParams: Record<string, LocationQueryValue | LocationQueryValue[]> = { ...to.query };
  delete queryParams.hash;

  if (!hash) {

    return navigateTo({ path: '/', query: queryParams });

  }

  const { event: ciaEvent } = useCia();
  ciaEvent.consent({
    consents: { newsletter: true },
    gdprPhone: '',
    additionalProps: {},
    hash,
  });

  const decodedHash = decodeBase64Json<DecodedHash>(hash);
  const languagePrefix = getLanguagePrefix(to.path);

  if (decodedHash?.redirect_to) {

    const redirectTo = decodedHash.redirect_to;
    const params: Record<string, LocationQueryValue | LocationQueryValue[] | string> = { ...queryParams };

    if (decodedHash.voucher_code) {

      params.subscribe = encodeVoucherPayload({
        voucher_code: decodedHash.voucher_code,
      });

    }

    return navigateTo({
      path: languagePrefix + withoutLeadingSlash(redirectTo),
      query: params,
    });

  }

  return navigateTo({ path: '/', query: queryParams });

}

function handleMSPageRequest(query: LocationQuery) {

  // TODO perform full redirection to new Management Subscription page with keeping all query parameters
  // After loading this page, hash from url will be used to fetch and save user consents without logging in
  return navigateTo({ path: '/', query });

}
